import { render, staticRenderFns } from "./onCreated-editor.vue?vue&type=template&id=3b006274&scoped=true"
import script from "./onCreated-editor.vue?vue&type=script&lang=js"
export * from "./onCreated-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b006274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b006274')) {
      api.createRecord('3b006274', component.options)
    } else {
      api.reload('3b006274', component.options)
    }
    module.hot.accept("./onCreated-editor.vue?vue&type=template&id=3b006274&scoped=true", function () {
      api.rerender('3b006274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onCreated-editor.vue"
export default component.exports